<template lang='pug'>
  .new-ec-campaign
    .overview__header
      el-breadcrumb(
        separator="/"
      )
        el-breadcrumb-item(
          :to="{ path: '/ec-campaign/list' }"
        ) {{ $t('媒体投放项目') }}
        el-breadcrumb-item 新建项目
      .header__right
          i.iconfont.icon-arrow_left
          el-button(
            type="text"
            @click="$router.push('/ec-campaign/list')"
          ) {{ $t('返回') }}
    el-card
      p.card-title {{ $t('基础信息') }}
      hr.divider
      el-form(
        ref="form"
        :rules="rules"
        :model="basicForm"
        label-width="180px"
        label-position="left"
        style="margin-top: 24px"
      )
        el-form-item(
          :label="$t('项目名称')"
          prop="campaign_name"
        )
          el-input(
            v-model="basicForm.campaign_name"
            :placeholder="$t('示例: 猫超_发水_清扬_201910_大牌风云投放')"
          )
          el-tooltip(
            style="margin-left: 10px"
            :content="$t('店铺_品类_品牌_年份月份_活动名称')"
            placement="top"
          )
            i.el-icon-question(
              style="font-size: 14px"
            )
        el-form-item(
          :label="$t('品类')"
          prop="brand_category_id"
        )
          el-select(
            v-model="basicForm.brand_category_id"
            :placeholder="$t('请选择品牌类别')"
            @change="onBrandCategoryChange"
            @visible-change="$forceUpdate()"
          )
            el-option(
              v-for="o, i in brandCategoryList"
              :key="i"
              :value="o.brand_category_id"
              :label="o.brand_category_name"
            )
        el-form-item(
          :label="$t('品牌')"
          prop="brand_id"
        )
          el-select(
            v-model="basicForm.brand_id"
            :placeholder="$t('请选择品牌')"
          )
            el-option(
              v-for="o, i in brandList"
              :key="i"
              :value="o.brand_id"
              :label="o.brand_name"
            )
        el-form-item.is-required(
          :label="$t('投放渠道')"
        )
          el-col(
            style="width:210px"
          )
            el-form-item(
              prop="channel_id"
            )
              el-select.form-selector(
                style="margin-right: 24px"
                v-model="basicForm.channel_id"
              )
                el-option(
                  v-for="(o, i) in channelShopList"
                  :key="i"
                  :value="o.channel_id"
                  :label="o.channel_name"
                )
          el-col(
            style="width:200px;margin-left: 10px"
          )
            el-form-item(
              prop="shop_id"
            )
              el-select.form-selector(
                style="margin-right: 24px"
                v-model="basicForm.shop_id"
              )
                el-option(
                  v-for="(o, i) in shopList"
                  :key="'shop' + i"
                  :value="o.shop_id"
                  :label="o.shop_name"
                )
        el-form-item(
            :label="$t('项目背景')"
            prop="introduction"
          )
            el-input(
              v-model="basicForm.remark"
              type="textarea"
              :rows="8"
              style="width: 425px"
              :placeholder="$t('请描述项目相关背景(<=500字)')"
            )
      footer-button(
        @confirm="onSubmit"
        @cancel="onCancel"
      )
</template>

<script>
import axios from 'axios'
import FooterButton from '@/components/FooterButton'
import { format4backend } from '@/umcc/util'
export default {
  components: {
    FooterButton
  },
  data () {
    return {
      channelShopList: [],
      brandCategoryList: [],
      basicForm: {
        status: 0,
        campaign_name: '',
        brand_category_id: null,
        brand_id: null
      },
      rules: {
        campaign_name: [{
          required: true, message: this.$t('请填写项目名称'), trigger: 'blur'
        }],
        brand_category_id: [{
          required: true, message: this.$t('请填写品类'), trigger: 'blur'
        }],
        brand_id: [{
          required: true, message: this.$t('请填写品牌'), trigger: 'blur'
        }],
        channel_id: [
          {
            required: true, message: this.$t('请填写渠道'), trigger: 'blur'
          }
        ],
        shop_id: [
          {
            required: true, message: this.$t('请填写商店'), trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    brandList () {
      return this.brandCategoryList.length !== 0 && this.basicForm.brand_category_id != null ? this.brandCategoryList.find(b => b.brand_category_id === this.basicForm.brand_category_id).children : []
    },
    shopList () {
      return this.channelShopList.length !== 0 && this.basicForm.channel_id != null ? this.channelShopList.find(b => b.channel_id === this.basicForm.channel_id).children : []
    }
  },
  mounted () {
    this.getBrandTreeStructure()
    this.getAllChannelShopTree()
  },
  methods: {
    getBrandTreeStructure () {
      axios.get('/common/getBrandTreeStructure', {
        params: {
          campaign_type: 2
        }
      })
        .then(res => {
          this.brandCategoryList = res
        })
    },
    getAllChannelShopTree () {
      axios.get('/management/ec/getAllChannelShopTree')
        .then(res => {
          this.channelShopList = res
        })
    },

    onBrandCategoryChange () {
      const firstBrand = this.brandCategoryList.find(b => b.brand_category_id === this.basicForm.brand_category_id).children[0]
      if (firstBrand) {
        this.basicForm.brand_id = firstBrand.brand_id
      }
    },

    onSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.handleConfirm()
        }
      })
    },

    onCancel () {
      this.$router.push('/ec-campaign/list')
    },

    handleConfirm () {
      const params = {
        campaign: {
          campaign_name: this.basicForm.campaign_name,
          channel_id: this.basicForm.channel_id,
          shop_id: this.basicForm.shop_id,
          remark: this.basicForm.remark
        },
        campaign_brand: [
          {
            brand_category_id: this.basicForm.brand_category_id,
            brand_id: this.basicForm.brand_id
          }
        ]
      }
      this.loading = true
      axios.post('/management/ec/saveCampaign', format4backend(params))
        .then((res) => {
          this.loading = false
          this.isSaved = true
          this.$confirm(this.$t('主项目创建成功，您需要新建子项目'), this.$t('提示'), {
            confirmButtonText: this.$t('点击前往'),
            cancelButtonText: this.$t('返回')
          })
            .then(() => {
              this.$store.commit('campaign/setId', res.campaign_id)
              this.$store.commit('campaign/setSubFinalScopeId', null)
              // this.$store.commit('campaign/setECCampaignInfo', res)
              this.$store.dispatch('campaign/updateECTab')
              this.$router.push({
                path: '/ec-campaign/process'
              })
            })
            .catch(() => {
              this.$store.commit('campaign/setId', res.campaign_id)
              this.$store.commit('campaign/setSubFinalScopeId', null)
              this.$router.push('/ec-campaign/overview')
            })
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang='stylus'>
.new-ec-campaign
  .el-input,.el-textarea
    width 425px
  .divider
    border 0
    border-top 1px solid $gray2
    margin 16px  0
  .form-selector
    .el-input
     width 205px
  .footer-button
    margin-left 180px
  .overview__header
    display flex
    margin-bottom 10px
    align-items center
    justify-content space-between
    .header__right
      display flex
      align-items center
      i
        color $main
        margin-right: -2px;
      .el-button
        padding-top 8px
        width auto !important
</style>
